var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

var TableData = function TableData(props) {
  var children = props.children,
      className = props.className,
      iconClassName = props.iconClassName,
      expanded = props.expanded,
      other = _objectWithoutProperties(props, ['children', 'className', 'iconClassName', 'expanded']);

  var tableDataClasses = classNames(className);

  var iconClasses = classNames(iconClassName, 'bx--table-expand__svg');

  var style = expanded ? {
    transform: 'rotate(90deg)'
  } : {};

  return React.createElement(
    'td',
    _extends({}, other, { className: tableDataClasses }),
    expanded === undefined ? children : React.createElement(Icon, {
      className: iconClasses,
      name: 'chevron--right',
      description: 'expand row',
      style: style,
      tabIndex: 0,
      onKeyPress: function onKeyPress(evt) {
        if (props.onClick && (evt.which === 13 || evt.which === 32)) {
          props.onClick(evt);
        }
      }
    })
  );
};

TableData.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  expanded: PropTypes.bool
};

export default TableData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/TableData/TableData.js
// module id = 376
// module chunks = 0